var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLyloIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .c {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": 27
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.05,7.98s0,0,.01,0,0,0,.01,0c1.93,0,3.49-1.56,3.49-3.49s-1.56-3.49-3.49-3.49c0,0,0,0-.01,0s0,0-.01,0c-1.93,0-3.49,1.56-3.49,3.49,0,1.93,1.56,3.49,3.49,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.82,15.12l-3.94-2.86-1.24-3.04c-.24-.58-.8-.92-1.39-.91h0s-2.25,0-2.25,0h-2.25c-.59-.01-1.15.33-1.39.91l-1.24,3.04-3.94,2.86c-.66.48-.8,1.39-.32,2.05.29.39.73.6,1.19.6.3,0,.6-.09.86-.28l4.26-3.09-.11,1.12-4.02,4.08c-.56.58-.72,1.44-.4,2.18.32.74,1.04,1.22,1.85,1.22h1.92c-.5-.45-.81-1.12-.81-1.87,0-1.35,1.02-2.44,2.28-2.44h2.19c.72,0,1.29.59,1.29.59h-3.48c-.96,0-1.74.83-1.74,1.86s.78,1.86,1.74,1.86h3.37s.08,0,.11,0h4.07c.81,0,1.53-.48,1.85-1.22.32-.74.16-1.6-.4-2.18l-3.94-4.08h0l-.11-1.1,4.26,3.09c.26.19.56.28.86.28.45,0,.9-.21,1.19-.6.48-.66.33-1.57-.32-2.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyloIcon);
export default __webpack_public_path__ + "static/media/LYLO-icon.508a68598e208186b28193ea3dce83b9.svg";
export { ForwardRef as ReactComponent };